import { BookOpen, Search, Trash2, Volume2 } from "lucide-react";
import { useMemo, useState } from "react";
import type { DictionaryWord } from "../types";

type DictionaryPanelProps = {
  words: DictionaryWord[];
  loading: boolean;
  onRemove: (id: string) => void;
  onSpeak: (word: DictionaryWord) => void;
  onSelect: (word: DictionaryWord) => void;
};

export function DictionaryPanel({
  words,
  loading,
  onRemove,
  onSpeak,
  onSelect,
}: DictionaryPanelProps) {
  const [query, setQuery] = useState("");
  const filtered = useMemo(() => {
    const value = query.trim().toLocaleLowerCase();
    if (!value) return words;
    return words.filter(
      (word) =>
        word.word.toLocaleLowerCase().includes(value) ||
        word.translation.toLocaleLowerCase().includes(value),
    );
  }, [query, words]);

  return (
    <section className="content-panel">
      <div className="section-title-row">
        <div>
          <p className="eyebrow">KİŞİSEL KOLEKSİYON</p>
          <h1>Sözlüğüm</h1>
          <p className="muted">Öğrendiğin kelimeler tek yerde, istediğin zaman yanında.</p>
        </div>
        <span className="count-badge">{words.length} kelime</span>
      </div>

      <label className="dictionary-search">
        <Search size={19} />
        <input
          value={query}
          onChange={(event) => setQuery(event.target.value)}
          placeholder="Kelime veya çeviri ara…"
        />
      </label>

      {loading ? (
        <p className="muted">Sözlüğün yükleniyor…</p>
      ) : filtered.length === 0 ? (
        <div className="large-empty">
          <BookOpen size={34} />
          <h2>{query ? "Aradığın kelime bulunamadı" : "Sözlüğün seni bekliyor"}</h2>
          <p>PDF okurken bir kelime seçip “Sözlüğe ekle” düğmesine dokun.</p>
        </div>
      ) : (
        <div className="dictionary-grid">
          {filtered.map((word) => (
            <article className="dictionary-card" key={word.id}>
              <button className="dictionary-main" onClick={() => onSelect(word)}>
                <span className="dictionary-language">{word.detectedLanguage}</span>
                <h2>{word.word}</h2>
                <strong>{word.translation}</strong>
                <p>{word.contextMeaning || word.definition}</p>
              </button>
              <div className="dictionary-actions">
                <button className="icon-button" onClick={() => onSpeak(word)} aria-label="Sesli oku">
                  <Volume2 size={18} />
                </button>
                <button className="icon-button danger" onClick={() => onRemove(word.id)} aria-label="Sil">
                  <Trash2 size={18} />
                </button>
              </div>
            </article>
          ))}
        </div>
      )}
    </section>
  );
}

